import ApiService from "./ApiService";
import { getCookie } from "./CommonService";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./basequery";

const servicePrefix = "/competitions";

const csrftoken = getCookie("csrftoken");

export const competitionService = createApi({
  reducerPath: "competitionApi",
  baseQuery,
  // refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  tagTypes: ["competitions"],
  endpoints: (build) => ({
    getHostedCompetitions: build.query({
      query: () => ({
        url: `${servicePrefix}/user/hosted-competitions/`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getCompetition: build.query({
      query: ({ slug }) => ({
        url: `${servicePrefix}/${slug}/`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getSubmissions: build.query({
      query: ({ id }) => ({
        url: `${servicePrefix}/submission/${id}/`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getSubmission: build.query({
      query: ({ id }) => ({
        url: `${servicePrefix}/submission/detail/${id}/`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    patchSubmission: build.mutation({
      query: ({ submissionId, ...data }) => {
        return {
          url: `${servicePrefix}/submission/detail/${submissionId}/`,
          method: "patch",
          data: { ...data },
        };
      },
    }),
  }),
});

export const {

  useGetHostedCompetitionsQuery,
  useGetCompetitionQuery,
  useGetSubmissionsQuery,
  useGetSubmissionQuery,
  usePatchSubmissionMutation,
} = competitionService;

